<template>
  <div class="resourcecenter">
    <div class="page-title">
      <div>资源中心</div>
    </div>
    <div class="nav-tabpanel-box">
      <div :class="['item-nav-box', selTabIndex === 0 ? 'active' : '']" @click="handleSelTab(0)">
        我的好友（{{friendTotal}}）
      </div>
      <div :class="['item-nav-box', selTabIndex === 1 ? 'active' : '']" @click="handleSelTab(1)">
        开发资源
      </div>
      <div :class="['item-nav-box', selTabIndex === 2 ? 'active' : '']" @click="handleSelTab(2)">
        产品资源
      </div>
    </div>
    <template v-if="selTabIndex === 0">
      <div class="myfriendlist-box">
        <div class="myfriendlist-inner" v-infinite-scroll="loadMoreData" :infinite-scroll-disabled="disabledLoadMore">
          <template v-if="friendList && friendList.length !== 0">
            <div v-for="(item, idx) in friendList" :key="idx" class="myfriend-box">
            <div class="myfriend-base-box">
              <img class="icon-avatar" v-if="item.weichat_img" :src="item.weichat_img" />
              <img class="icon-avatar" v-else src="@/assets/default_img.png" />
              <div class="base-info">
                <div class="name">{{ item.nick_name }}</div>
                <div :class="['tag-user', (item.user_remark_018=='1802'||item.user_remark_018=='1803'||item.user_remark_018=='1804')? 'isvip' : '']">
                  <div class="icon-identify"></div>
                  <div>{{ (item.user_remark_018=='1802'||item.user_remark_018=='1803'||item.user_remark_018=='1804') ? "已认证" : "未认证" }}</div>
                </div>
                <div class="reg-time">注册时间：{{ item.time_register }}</div>
              </div>
            </div>
            <div v-if="item.isRecommend" class="tag-recommend">推荐人</div>
          </div>
          </template>
          <NoneData v-else></NoneData>
        </div>
      </div>
    </template>
    <template v-if="selTabIndex === 1">
      <div class="source-table-box">
        <div class="row-table head">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">开发资源</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="label">我的资源</div>
          </div>
          <div class="professional">
            <div class="lable-price-box">
              <div class="lable-cont">{{ userIsVip ? "我的资源" : "专业版" }}</div>
              <!-- <div class="price-box"><span class="price">¥{{price}}</span>元/月</div> -->
            </div>
            <div class="btn-box">
              <!-- <el-button class="custom-button btn-ff3333 btn-upgrade"  @click.stop="handleUpdateNow">{{
                userIsVip ? "立即续费" : "立即升级"
              }}</el-button> -->
            </div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">白名单数量</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">1个</div>
          </div>
          <div class="professional">
            <div class="mysourceval">10个</div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">案例库权限</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">1个</div>
          </div>
          <div class="professional">
            <div class="mysourceval">不限</div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">发布环境</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">
              <img class="icon-forbid" src="@/assets/icon_forbid.png" />
            </div>
          </div>
          <div class="professional">
            <div class="mysourceval">
              <img class="icon-check-blue" src="@/assets/icon_check_blue.png" />
            </div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">发布服务器权限</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">
              <img class="icon-forbid" src="@/assets/icon_forbid.png" />
            </div>
          </div>
          <div class="professional">
            <div class="mysourceval">
              <img class="icon-check-blue" src="@/assets/icon_check_blue.png" />
              <!-- <div class="icon-remind-box2">
                <img
                    class="icon_remind_red2"
                    src="@/assets/icon_remind_red.png"
                  />
              </div> -->
<!--              <el-tooltip placement="bottom" :enterable="true" popper-class="custom-tooltip">
                <div slot="content" class="custom-tooltip-inner">
                  首发项目：1024元/个；<br />第二个项目：819.2元/个；<br />第三个项目及以上：614.4元/个。
                </div>
                <div class="icon-remind-box">
                  <img class="icon_remind_red" src="@/assets/icon_remind_red.png" />
                </div>
              </el-tooltip>-->
              <!-- <img class="icon_remind_red" src="@/assets/icon_remind_red.png" /> -->
            </div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">发布项目权限</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">
              <img class="icon-forbid" src="@/assets/icon_forbid.png" />
            </div>
          </div>
          <div class="professional">
            <div class="mysourceval">
              <img class="icon-check-blue" src="@/assets/icon_check_blue.png" />
            </div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">商务支持</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">
              <img class="icon-forbid" src="@/assets/icon_forbid.png" />
            </div>
          </div>
          <div class="professional">
            <div class="mysourceval">帮你去谈客户</div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">技术支持</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">
              <img class="icon-forbid" src="@/assets/icon_forbid.png" />
            </div>
          </div>
          <div class="professional">
            <div class="mysourceval">帮你搞定复杂对接</div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">UI支持</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">
              <img class="icon-forbid" src="@/assets/icon_forbid.png" />
            </div>
          </div>
          <div class="professional">
            <div class="mysourceval">帮你搞定设计</div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="selTabIndex === 2">
      <div class="source-table-box">
        <div class="row-table head">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">产品资源</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="label">我的资源</div>
          </div>
          <div class="professional">
            <div class="lable-price-box">
              <div class="lable-cont">{{ userIsVip ? "我的资源" : "专业版" }}</div>
             <!-- <div class="price-box"><span class="price">¥{{price}}</span>元/月</div> -->
            </div>
            <div class="btn-box">
              <!-- <el-button class="custom-button btn-ff3333 btn-upgrade" @click.stop="handleUpdateNow">{{
                userIsVip ? "立即续费" : "立即升级"
              }}</el-button> -->
            </div>
          </div>
        </div>
        <div class="row-table normal-row">
          <div :class="['devlopsource', userIsVip ? 'isvip' : '']">
            <div class="label col1">独自开开发工具包下载次数</div>
          </div>
          <div v-if="!userIsVip" class="mysource">
            <div class="mysourceval">不限</div>
          </div>
          <div class="professional">
            <div class="mysourceval">不限</div>
          </div>
        </div>
      </div>
    </template>
    <CompCouponQrcode ref="compCouponQrcode"></CompCouponQrcode>
    <CompRecharge ref="compRecharge"></CompRecharge>
  </div>
</template>
<script>
import NoneData from "@/components/NoneData";
import CompCouponQrcode from "@/components/dialog/GetCouponQrcode";
import CompRecharge from "@/components/dialog/Recharge";
import pageCommon from "@/utils/pagecommon";
import goodsApi from "@/api/goods";
import resourcecenterApi from "@/api/resourceCenter";
export default {
  name: "ResourceCenter",
  components: {NoneData,CompCouponQrcode, CompRecharge},
  created() {
    let _this = this;
    _this.$store.dispatch("acCenterNavIndex", 4);
    _this.isRequesting=true;
    if (_this.selTabIndex === 0) {
      console.log(_this.upLineUser.length)
      _this.getUplineUser().then(()=>{
        _this.getFriendList();
      });
    }
  },
  mounted() {
    let _this = this;
  },
  data() {
    return {
      price:0,
      isvip: true,
      friendList: [],
      upLineUser: [],
      selTabIndex: 0,
      currentPage: 1,
      pageSize: 10,
      friendTotal: '',
      disabledLoadMore: false,
      isRequesting: false,
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      return user;
    },
    userIsVip: function () {
      let _this = this;
      if (_this.userInfo && _this.userInfo.user_remark_012 && _this.userInfo.user_remark_012 === '1202') {
        return true;
      }
      return false;
    }
  },
  filters: {
  },
  methods: {
    getGoodsInfo: function () {
      let _this = this;
      let requestData = {
        isloading: true
      }
      pageCommon.apiRequestCommon(goodsApi, "showGoodsInfo", requestData).then(
        (res) => {
          if (res && res.public_goods_list && res.public_goods_list.length > 0) {
            let goodsInfo = res.public_goods_list[0];
            //3个月打9折，6个月打8折，12个月5折
            let price = goodsInfo.publicGoodsSupply4Shop.new_price_4_shop_retail;
            _this.price = price;
          }
          else {
          }
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    getUplineUser: function () {
      let _this = this;
      console.log(_this.userInfo)
      return new Promise((resolve, reject) => {
        console.log(_this.upLineUser.length)
        if (_this.userInfo) {
          let requestData = {
            begin_idx: (_this.currentPage - 1) * _this.pageSize,
            limit: _this.pageSize,
            id_public_user_info: _this.userInfo.upline_id_user,
            isloading: true,
          };
          pageCommon.apiRequestCommon(resourcecenterApi, "getUplineUser", requestData).then(
            (res) => {
              if (res.page_content.length) {
                res.page_content[0].isRecommend = true
                _this.upLineUser.unshift(res.page_content[0])
              } else {
                _this.upLineUser = []
              }
              resolve();
            },
            (err) => {
              _this.isRequesting = false;
              _this.upLineUser=[];
              if (err.sysUserLoginError) {
                _this.$message.error("系统异常，请稍后刷新重试！");
              } else {
                _this.$message.error(err.data.msg);
              }
              reject();
            }
          );
        }
        else {
          resolve();
        }
      })

    },
    getFriendList: function () {
      let _this = this;
      let requestData = {
        begin_idx: (_this.currentPage - 1) * _this.pageSize,
        limit: _this.pageSize,
        id_public_user_info: _this.userInfo.id_public_user_info,
        isloading: true,
      };
      pageCommon.apiRequestCommon(resourcecenterApi, "getFriendList", requestData).then(
        (res) => {
          this.friendTotal=res.result_num
          if (res.page_content.length) {
            let friendList = res.page_content;
            if (friendList.length < _this.pageSize) {
              _this.disabledLoadMore = true;
            }
            // 用concat
            _this.friendList.push(...friendList);
            _this.isRequesting = false;
            if (_this.upLineUser.length && !_this.friendList[0].isRecommend) {
              _this.friendList.unshift(_this.upLineUser[0])
            }
          } else {
            _this.friendList = []
          }
        },
        (err) => {
          // _this.collectList = [];
          _this.isRequesting = false;
          _this.projectList = [];
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    loadMoreData: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting=true;
      _this.currentPage += 1;
      _this.getFriendList();
    },
    handleSelTab: function (idx) {
      let _this = this;
      if (_this.selTabIndex === idx) {
        return;
      }
      if (idx === 0) {
        _this.getUplineUser().then(()=>{
          _this.getFriendList()
        })
      } else {
        _this.getGoodsInfo()
      }
      _this.selTabIndex = idx;
    },
    handleUpdateNow: function () {
      let _this = this;
      _this.$refs.compRecharge.handleShow();
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";
.resourcecenter {
  position: relative;
  width: 100%;
  // height: 100%;
  height: 1135px;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .nav-tabpanel-box {
    position: relative;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    margin-top: 40px;
    .item-nav-box {
      position: relative;
      height: 32px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      color: #222222;
      line-height: 18px;

      box-sizing: border-box;
      cursor: pointer;
      margin-right: 64px;
      &.active {
        color: #ec4040;
        font-weight: bold;
        &::after {
          position: absolute;
          width: 100%;
          content: "";
          height: 4px;
          background: #ec4040;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
  .myfriendlist-box {
    position: relative;
    width: 100%;
    flex: 1;
    margin-top: 32px;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .myfriendlist-inner {
      position: relative;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      flex-wrap: wrap;
      .myfriend-box {
        position: relative;
        width: 495px;
        height: 182px;
        margin-top: 50px;
        &:nth-child(1) {
          margin-top: 0;
        }
        &:nth-child(2) {
          margin-top: 0;
        }
        .myfriend-base-box {
          position: relative;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          flex-direction: row;
          .icon-avatar {
            position: relative;
            width: 100px;
            height: 100px;
            margin-right: 32px;
            border-radius: 4px;
            box-sizing: border-box;
          }
          .base-info {
            .name {
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #222222;
              line-height: 18px;
              text-align: left;
            }
            .tag-user {
              position: relative;
              width: 90px;
              height: 30px;
              border: 1px solid #999999;
              border-radius: 4px;
              box-sizing: border-box;
              display: flex;
              display: -webkit-flex;
              flex-direction: row;
              align-items: center;
              padding-left: 5px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #666666;
              line-height: 14px;
              margin-top: 25px;
              .icon-identify {
                position: relative;
                width: 20px;
                height: 20px;
                margin-right: 5px;
                background-image: url(~@/assets/icon_free2.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
              &.isvip {
                width:110px;
                border-color: #ec4040;
                color: #ec4040;
                .icon-identify {
                  background-image: url(~@/assets/icon_vip2.png);
                }
              }
            }
            .reg-time {
              position: relative;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              line-height: 14px;
              text-align: left;
              margin-top: 14px;
            }
          }
        }
        .tag-recommend {
          position: relative;
          width: 72px;
          height: 26px;
          line-height: 26px;
          background: linear-gradient(0deg, #ec4040 1%, #ff7272 100%);
          border-radius: 4px;
          box-sizing: border-box;

          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #fefefe;
          margin-top: 10px;
          margin-left: 14px;
        }
      }
    }
  }
  .source-table-box {
    position: relative;
    width: 100%;
    flex: 1;
    margin-top: 32px;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .row-table {
      position: relative;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;

      .devlopsource {
        position: relative;
        width: 300px;
        height: 100%;
        border-right: 1px solid #eeeeee;
        box-sizing: border-box;
        &.isvip {
          width: 645px;
          box-sizing: border-box;
        }
      }
      .mysource {
        position: relative;
        width: 345px;
        height: 100%;
        border-right: 1px solid #eeeeee;
        box-sizing: border-box;
      }
      .professional {
        position: relative;
        flex: 1;
        height: 100%;
      }
      .label {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 18px;
      }
      &.head {
        height: 160px;
        border: 1px solid #eeeeee;
        border-radius: 0px 4px 0px 0px;
        box-sizing: border-box;
        .label {
          margin-top: 33px;
          font-size: 22px;
          &.col1 {
            text-align: left;
            padding-left: 41px;
          }
        }
        .professional {
          position: relative;
          height: 100%;
          height: 158px;
          background: linear-gradient(45deg, #080808 0%, #2d2d2d 99%);
          border-radius: 0px 4px 0px 0px;
          box-sizing: border-box;
          .lable-price-box {
            position: relative;
            width: 100%;
            padding-left: 40px;
            padding-right: 40px;
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            margin-top: 30px;
            margin-bottom: 30px;
            .lable-cont {
              position: relative;
              font-size: 22px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ffffff;
              line-height: 22px;
            }
            .price-box {
              position: relative;

              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ffffff;
              line-height: 16px;
            }
            .price {
              position: relative;
              font-size: 32px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #ec4040;
              line-height: 32px;
              padding-right: 6px;
            }
          }
          .btn-box {
            position: relative;
            width: 100%;
            text-align: center;
            .btn-upgrade {
              height: 46px;
              line-height: 46px;

              font-size: 18px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #ffffff;
            }
          }
        }
      }
      &.normal-row {
        height: 96px;
        border: 1px solid #eeeeee;
        border-radius: 0px 4px 0px 0px;
        border-top: none;
        box-sizing: border-box;
        align-items: center;
        .label {
          margin-top: 39px;
          &.col1 {
            text-align: left;
            padding-left: 41px;
          }
        }
        .mysourceval {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: center;

          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #222222;

          .icon-forbid {
            width: 28px;
            height: 28px;
          }
          .icon-check-blue {
            position: relative;
            width: 28px;
            height: 28px;
          }
          .hadremind-text {
            line-height: 18px;
          }
          .icon-remind-box {
            position: absolute;
            width: 18px;
            height: 18px;
            // top: 39px;
            top: 50%;
            transform: translate(0, -50%);
            -webkit-transform: translate(0, -50%);
            right: 117px;
            cursor: pointer;
            .icon_remind_red {
              position: relative;
              width: 18px;
              height: 18px;
              vertical-align: top;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }
  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .ordertype {
    width: 116px;
    text-align: left;
  }
  .orderpaytype {
    width: 114px;
    text-align: center;
  }
  .paytime {
    width: 198px;
    text-align: center;
  }
  .couponmoney {
    width: 124px;
    text-align: center;
  }
  .surplusmoney {
    width: 137px;
    text-align: center;
  }
  .realpay {
    width: 142px;
    text-align: center;
  }
  .orderstatus {
    width: 98px;
    text-align: right;
  }
  .distributionid {
    width: 151px;
    text-align: left;
  }
  .avatar {
    width: 42px;
    text-align: center;
    .user-avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
  }
  .username {
    width: 132px;
    text-align: center;
  }
  .userphone {
    width: 163px;
    text-align: center;
  }
  .distributionordertype {
    width: 141px;
    text-align: center;
  }
  .distributionmoney {
    width: 155px;
    text-align: center;
  }
  .fanyongmoney {
    width: 131px;
    text-align: center;
  }
  .table-header-box {
    position: relative;
    align-items: baseline;
    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 36px;
    margin-bottom: 20px;
    align-items: center;
    &.recharge {
      align-items: baseline;
      padding-top: 18px;
    }
    .status-cell {
      text-align: center;
    }
    .creattime-cell {
      text-align: center;
    }
  }

  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .datalist-row {
    position: relative;
    height: 120px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0;
    }
    .order-num-box {
      position: relative;
      width: 988px;
      height: 40px;
      background: #f4f4f4;
      border-radius: 4px 4px 0px 0px;
      box-sizing: border-box;
      margin: 0 auto;
      padding-left: 24px;

      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
      text-align: left;
      .order-num {
        padding-left: 10px;
      }
      .distribute-paytime {
        padding-left: 24px;
      }
    }
    .cell-row {
      margin-top: 31px;
    }
    &.distribution {
      .cell-row {
        margin-top: 18px;
      }
    }
    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }
    .couponmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .surplusmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
    .realpay {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
    }
    .distributionmoney {
      //  font-size: 16px;
      //     font-family: Source Han Sans CN;
      //     font-weight: bold;
      //     color: #000000;
    }
    .fanyongmoney {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ec4040;
    }
  }
}
</style>
